import { render, staticRenderFns } from "./UsersImport.vue?vue&type=template&id=6b6ad588&"
import script from "./UsersImport.vue?vue&type=script&lang=js&"
export * from "./UsersImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports